export default {
    grid: {
        breakPoints: [
            {
                w: 904,
                className: 'cards__list--4-columns',
            },
            {
                w: 672,
                className: 'cards__list--3-columns',
            },
            {
                w: 448,
                className: 'cards__list--2-columns',
            },
        ],
        modalOffset: 64,
        ampModalOffset: 430,
    },
    lazyLoad: {
        lazyLoadImages: 8,
    },
};
